// Search actions sit outside a Component; delegate to the native theme dialog.
if (!window.argyreHeaderSearchBound) {
  window.argyreHeaderSearchBound = true;
  document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('header-component .search-action button');
    if (!trigger) return;
    const modal = document.getElementById('search-modal');
    if (!modal) return;
    await customElements.whenDefined('dialog-component');
    if (!modal.querySelector('dialog')?.open) modal.showDialog();
  });
}
